export default "__VITE_ASSET__fSiT4Wza__"